import { NgModule } from '@angular/core';
import { CommonModule } from 'app/common.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { SidebarNavModule } from 'shared/components/sidebar-nav/sidebar-nav.module';
import { InfoPostSidebarNavComponent } from './sidebar-nav.component';
import { InfoPostSidebarNavItemComponent } from '../sidebar-nav-item/sidebar-nav-item.component';
import { RouterModule } from '@angular/router';
import { InfoPostSidebarNavDrawerComponent } from "../sidebar-nav-drawer/sidebar-nav-drawer.component";
import {
  InfoPostSidebarNavSecondaryItemComponent
} from "../sidebar-nav-secondary-item/sidebar-nav-secondary-item.component";
import {
  InfoPostSidebarNavTertiaryItemComponent
} from "../sidebar-nav-tertiary-item/sidebar-nav-tertiary-item.component";

@NgModule({
  imports: [ClickOutsideModule, CommonModule, SidebarNavModule, RouterModule],
  exports: [
    InfoPostSidebarNavComponent,
    InfoPostSidebarNavItemComponent,
    InfoPostSidebarNavDrawerComponent,
    InfoPostSidebarNavSecondaryItemComponent,
    InfoPostSidebarNavTertiaryItemComponent
  ],
  declarations: [
    InfoPostSidebarNavComponent,
    InfoPostSidebarNavItemComponent,
    InfoPostSidebarNavDrawerComponent,
    InfoPostSidebarNavSecondaryItemComponent,
    InfoPostSidebarNavTertiaryItemComponent
  ],
  providers: [],
})
export class InfoPostSidenavBarModule { }
